import { init as initSentry } from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { SENTRY_DSN_PUBLIC } from '@/core/constants'

export default function initReporter(Vue) {
  if (!SENTRY_DSN_PUBLIC) return
  return initSentry({
    dsn: SENTRY_DSN_PUBLIC,
    integrations: [new VueIntegration({
      Vue,
      attachProps: true,
      logErrors: true,
    })],
  });
}

// Sentry.captureException(new Error('example'));
